export const SETUP_APPLICATION_PREVIEW_LINK_COPY =
  'Preview the link that candidates will use to apply for this job.';

export const SETUP_APPLICATION_ADD_URL_COPY =
  "Enter the URL where candidates will apply, such as a public job board or your company's careers page.";

export const SETUP_APPLICATION_DEFAULT_URL_COPY =
  'Enter the URL of the job board or careers site where candidates will apply, such as a public job board or careers site.';
